import React from 'react';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import { formatPriceWithCurrency } from '../../utils/formatPrice';

const BulkMarkPaidConfirmModal = ({
  visible,
  onClose,
  onConfirm,
  count,
  totalAmount,
  loading,
  title = 'Potvrda isplate provizije',
  itemSingular = 'proviziju',
  itemPlural = 'provizije',
}) => (
  <Modal
    open={visible}
    title={title}
    onCancel={onClose}
    footer={[
      <Button
        key="cancel"
        onClick={onClose}
        disabled={loading}
        className="btn-tertiary"
      >
        Otkaži
      </Button>,
      <Button
        key="confirm"
        type="primary"
        loading={loading}
        onClick={onConfirm}
        className="btn-primary"
      >
        Da, označi kao realizovano
      </Button>,
    ]}
  >
    <p>
      Da li ste sigurni da želite da označite <strong>{count}</strong>{' '}
      {count === 1 ? itemSingular : itemPlural} kao{' '}
      {count === 1 ? 'realizovanu' : 'realizovane'}?
    </p>
    <p>
      Ukupan iznos: <strong>{formatPriceWithCurrency(totalAmount || 0)}</strong>
    </p>
  </Modal>
);

BulkMarkPaidConfirmModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  totalAmount: PropTypes.number,
  loading: PropTypes.bool,
  title: PropTypes.string,
  itemSingular: PropTypes.string,
  itemPlural: PropTypes.string,
};

export default BulkMarkPaidConfirmModal;
